import types from '@/store/mutation-types';

export default {
    state: {
        asideHeight: '',             // 页面高度
        asideWidth: '',             // 页面高度
        loginInfo: '',               // 登录信息
    },
    mutations: {
        [types.SET_ASIDE_HEIGHT](state, data) {
            state.asideHeight = data;
        },
        [types.SET_ASIDE_WIDTH](state, data) {
            state.asideWidth = data;
        },
        [types.SET_LOGIN_INFO](state, data) {
            state.loginInfo = data;
        },
    },
};
